import styles from './Divider.module.css';

const Divider = () => {
  return (
    <div className={styles.divider}>
      <div className={styles.circles}></div>
    </div>
  );
};

export default Divider;
